module.exports = __webpack_public_path__ + "static/media/smm.2c0875ff.jpg";